import { getVoucherList } from '@/api/voucher-list';
import { VoucherItem, ListParamType, VoucherType } from '@/types/voucher';
import moment from 'moment';
import { i18n } from '@/i18n';
import { getServerDate } from '@/util/dateHelper';
import { unionBy } from 'lodash-es';
let curCardCache: VoucherItem & {isInValid: boolean};
// 由于目前赶年前封版本，后台不改动，临时前端先全部查出来之后进行排序展示
const CardBgColorMap = {
  [VoucherType.GOV]: '#6FE05C',
  [VoucherType.PROM]: '#07C160',
};
/** 获取正常的有效消费券（这里不包含退款消费券） */
const fetchNormalList = async () => {
  const baseConfig = {
    limit: 10,
    offset: 0,
  };
  const res = await getVoucherList({
    ...baseConfig,
    type: ListParamType.NORMAL,
  });
  console.log('获取正常的有效消费券', res);
  return res || [];
};

/** 获取退款消费券 */
const fetchRefundList = async () => {
  const baseConfig = {
    limit: 10,
    offset: 0,
  };
  const res = await getVoucherList({
    ...baseConfig,
    type: ListParamType.REFUND,
  });
  console.log('获取退款消费券', res);
  return res || [];
};


/** 获取已过期的普通消费券（这里不包含退款消费券） */
export const fetchExpiredList = async () => {
  const baseConfig = {
    limit: 10,
    offset: 0,
  };
  const res = await getVoucherList({
    ...baseConfig,
    type: ListParamType.EXPIRED,
  });
  console.log('获取已过期的普通消费券', res);
  return res || [];
};

/** 获取所有的消费券列表 */
export const getAllVoucherList = async (): Promise<VoucherItem[]> => {
  const res = await Promise.all([
    fetchNormalList(),
    fetchRefundList(),
  ]);
  let joinVoucherList: VoucherItem[]  = [];
  res.forEach((item) => {
    joinVoucherList = [...joinVoucherList, ...item];
  });
  /** 根据userCvId去重一下，因为此次改动后端type=1的券也会返回type为4的券，为了保证线上用户体验，不出现缺少券或者重复券的问题先两边都查出来之后进行去重 */
  return unionBy(joinVoucherList, 'userCvId');
};

// 转化为时间搓
export const dateStringToTime = (dateString: string) => moment(dateString).valueOf();

/** 判断是否在可用期间 */
export const isValid = (dateString: string) => {
  const curTime = getServerDate().getTime();
  const cvStartTime = moment(dateString).valueOf();
  return cvStartTime <= curTime;
};

/** 根据时间排序 */
export const sortByTime = (arr: VoucherItem[], key: 'expireTime' | 'receiveTime'): VoucherItem[] => arr.sort((a, b) => dateStringToTime(a[key]) - dateStringToTime(b[key]));

/** 先展示政府消费券，再展示平台消费券 按照领取时间排序 未过期的消费券 */
export const sortVoucherList = (arr: VoucherItem[]) => {
  const govVoucher = arr.filter(item => item.cvType === VoucherType.GOV);
  const promVoucher = arr.filter(item => item.cvType === VoucherType.PROM);
  return [...sortByTime(govVoucher, 'receiveTime'), ...sortByTime(promVoucher, 'receiveTime')];
};

/** 按照过期时间排序 已过期的消费券 */
export const sortExpiredList = (arr: VoucherItem[]) => sortByTime(arr, 'expireTime');

/** 根据券类型返回背景颜色 */
export const getBgColor = (cv: VoucherItem) => CardBgColorMap[cv.cvType] || CardBgColorMap[VoucherType.PROM];

export const setCardCache = (cv: VoucherItem, isInValid: boolean) => {
  curCardCache = {
    ...cv,
    isInValid,
  };
};

export const getCardCache = () => curCardCache;

/** 消费券详情页配置 */
export function getCVBarConfig(cv: VoucherItem) {
  return [
    // {
    //   key: 'supportMch',
    //   name: i18n('查看支持商户'),
    //   desc: '',
    //   // clickStat: 'wallet.cvs.exdetail.merchant_click',
    //   link: 'https://prom.wechatpay.com.hk/hkwallet-prom-common/support-voucher-vendors.shtml?ADTAG=dhomepage',
    // },
    {
      key: 'tradeRecord',
      name: i18n('交易记录'),
      desc: '',
      clickStat: 'wallet.cvlist.detailpage.tx_click',
      link: `https://prom.wechatpay.com.hk/app/promotion/gov_coupons/gov_coupon_home_page.cgi?page=/record&cvType=${cv.cvType}&userCvId=${cv.userCvId}`,
    },
    // {
    //   key: 'VoucherNumber',
    //   name: i18n('消费券号码'),
    //   desc: cv.userCvId,
    //   // clickStat: 'wallet.cvs.exdetail.record_click',
    // },
    // {
    //   key: 'Question',
    //   name: i18n('常见问题'),
    //   desc: '',
    //   // clickStat: 'wallet.cvs.exdetail.faq_click',
    //   link: 'https://kf.qq.com/touch/product/hk_wallet_app.html?scene_id=kf3420#showmenu=1006964',
    // },
  ];
}
